import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const HowToMeasure = (props) => {
    const { t } = useTranslation();
    const { mannequinGender } = props;
    const mannequinClass = useMemo(() => {
        return 'sizechart__mannequin--' + mannequinGender;
    }, [mannequinGender]);
    return (React.createElement("div", { className: "sizechart sizechart--measure" },
        !['hand', 'dog'].includes(mannequinGender) && (React.createElement("p", { className: "mb-48 primary-xs section-description-measure", dangerouslySetInnerHTML: { __html: t('sizeguide.text', { link: props.contactformurl }) } })),
        React.createElement("div", { className: mannequinClass }),
        React.createElement("div", { className: "sizechart__wrapper" }, mannequinGender === 'dog' ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-32 primary-xs" }, t('sizeguide.howtomeasure.dog.intro')),
            React.createElement("dl", { className: "sizechart__legend" },
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "A"),
                    t('sizeguide.dog.neck')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.dog.neckdesc')),
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "B"),
                    t('sizeguide.dog.breast')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.dog.breastdesc')),
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "C"),
                    t('sizeguide.dog.length')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.dog.lengthdesc'))))) : mannequinGender === 'hand' ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-32 primary-xs" }, t('sizeguide.howtomeasure.hand.intro')),
            React.createElement("dl", { className: "sizechart__legend" },
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "A"),
                    t('sizeguide.palm')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.handdesc'))))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-32 primary-xs" }, t('sizeguide.howtomeasure.intro')),
            React.createElement("dl", { className: "sizechart__legend" },
                mannequinGender === 'woman' ? (React.createElement(React.Fragment, null,
                    React.createElement("dt", { className: "primary-xs" },
                        React.createElement("span", null, "A"),
                        t('sizeguide.howtomeasure.womanchest')),
                    React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.womanchestdesc')))) : (React.createElement(React.Fragment, null,
                    React.createElement("dt", { className: "primary-xs" },
                        React.createElement("span", null, "A"),
                        t('sizeguide.howtomeasure.chest')),
                    React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.chestdesc')))),
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "B"),
                    t('sizeguide.howtomeasure.waist')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.waistdesc')),
                React.createElement("dt", { className: "primary-xs" },
                    React.createElement("span", null, "C"),
                    t('sizeguide.howtomeasure.hips')),
                React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.hipsdesc')),
                mannequinGender != 'woman' && (React.createElement(React.Fragment, null,
                    React.createElement("dt", { className: "primary-xs" },
                        React.createElement("span", null, "D"),
                        t('sizeguide.howtomeasure.inseam')),
                    React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.inseamdesc')))),
                mannequinGender != 'woman' && mannequinGender != 'man' && (React.createElement(React.Fragment, null,
                    React.createElement("dt", { className: "primary-xs" },
                        React.createElement("span", null, "E"),
                        t('sizeguide.howtomeasure.length')),
                    React.createElement("dd", { className: "primary-xs" }, t('sizeguide.howtomeasure.lengthdesc')))))))),
        React.createElement("div", null)));
};
export default HowToMeasure;
